// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopHeader__wrapper--34t","promotions":"TopHeader__promotions--1oP"};